import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const {
	colors,
	common: { border },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		minHeight: 32,
	},
	extraTags: {
		padding: 0,
		borderRadius: 3,
	},
	extraTagsItem: {
		':not(:last-of-type)': {
			borderBottom: border,
		},
		alignItems: 'center',
		display: 'flex',
		fontSize: 12,
		padding: '3px 10px',
	},
	filterPill: {
		':nth-child(1n)': {
			margin: 4,
		},
	},
	moreTags: {
		':hover': {
			textDecoration: 'none',
		},
	},
	tag: {
		alignItems: 'center',
		display: 'flex',
	},
	// The shared list caps itself at 400px for the reporting table cell it was built for; this status line
	// spans the page, and maxTagsToDisplayInline already bounds how many pills can appear.
	tagList: {
		maxWidth: 'none',
	},
	tagTokenOpPrefix: {
		color: colors.text.dark,
	},
});
